import React from 'react';
import { Card, Typography, Button, Space } from 'antd';
import { ArrowLeftOutlined, MailOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

interface SupportProps {
  onBack: () => void;
}

const Support: React.FC<SupportProps> = ({ onBack }) => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:noreply@gamegarden.co';
  };

  return (
    <div 
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%)',
        padding: '20px'
      }}
    >
      <Card
        className="glass-effect"
        style={{
          width: '100%',
          maxWidth: '600px',
          borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-xl)',
          border: '1px solid var(--border-color)',
          background: 'rgba(30, 41, 59, 0.9)',
          backdropFilter: 'blur(20px)'
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
            style={{ 
              color: 'var(--text-secondary)', 
              padding: 0, 
              marginBottom: 16,
              fontSize: '14px'
            }}
          >
            Back to Game
          </Button>
        </div>

        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={2} className="text-gradient" style={{ margin: 0, marginBottom: 8 }}>
            Support
          </Title>
          <Text style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
            Need help? We're here to assist you!
          </Text>
        </div>

        <div style={{ marginBottom: 32 }}>
          <Title level={4} style={{ color: 'var(--text-primary)', marginBottom: 16 }}>
            Contact Us
          </Title>
          
          <Card
            hoverable
            onClick={handleEmailClick}
            style={{
              background: 'rgba(51, 65, 85, 0.8)',
              border: '1px solid var(--border-color)',
              borderRadius: 'var(--radius-lg)',
              marginBottom: 24,
              cursor: 'pointer'
            }}
          >
            <Space align="center" style={{ width: '100%' }}>
              <MailOutlined style={{ 
                color: 'var(--accent-color)', 
                fontSize: '24px' 
              }} />
              <div>
                <Text style={{ 
                  color: 'var(--text-primary)', 
                  fontSize: '16px', 
                  fontWeight: 500,
                  display: 'block'
                }}>
                  Send Email
                </Text>
                <Text style={{ color: 'var(--text-secondary)' }}>
                  Click to contact support
                </Text>
              </div>
            </Space>
          </Card>
        </div>

        <div style={{ marginBottom: 32 }}>
          <Title level={4} style={{ color: 'var(--text-primary)', marginBottom: 16 }}>
            Frequently Asked Questions
          </Title>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Card
              size="small"
              style={{
                background: 'rgba(51, 65, 85, 0.6)',
                border: '1px solid var(--border-color)',
                borderRadius: 'var(--radius-md)'
              }}
            >
              <Text style={{ color: 'var(--text-primary)', fontWeight: 500, display: 'block', marginBottom: 8 }}>
                Is my email address saved?
              </Text>
              <Text style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
                No, your email address is not saved. It is only used to display your name to other players during the game.
              </Text>
            </Card>

            <Card
              size="small"
              style={{
                background: 'rgba(51, 65, 85, 0.6)',
                border: '1px solid var(--border-color)',
                borderRadius: 'var(--radius-md)'
              }}
            >
              <Text style={{ color: 'var(--text-primary)', fontWeight: 500, display: 'block', marginBottom: 8 }}>
                How do I create a multiplayer room?
              </Text>
              <Text style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
                Choose "Multiplayer" from the main menu, then enter a room name. Share this room name with friends to play together.
              </Text>
            </Card>
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <Paragraph style={{ color: 'var(--text-muted)', fontSize: '14px', margin: 0 }}>
            Game Garden - Tea Garden Frontend v1.0
          </Paragraph>
        </div>
      </Card>
    </div>
  );
};

export default Support;